module.exports = __webpack_public_path__ + "static/img/teach-bg.28ce3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teach-bg.png
// module id = /ibA
// module chunks = 60